<!-- introduction Section -->
<section id="introduction" class="content-section">
    <div class="row" appDynamicDirection>
        <div class="container">
        <div class="col-lg-12">
            <h2 class="heading" i18n>Summary View</h2>
            <p i18n>The summary view is the highest-level overview of all policy critical components of SDG-PSS where data entered in the policy critical components is transformed into useable evidence. In the summary view, the datasets are synthesised and analysed to present key evidence that best assesses the progress against each SDG 6 target and indicator at the national level.
<br><br>
Reading across the summary view, each policy critical component of SDG-PSS is summarised under sub-components. The framework shows all evidence at the indicator-level and uses colour coding to easily identify progress across four classifications (adequate progress, in development, inadequate progress, and unknown/no data), and facilitates the identification of interlinkages between evidence in the summary view and the reporting pages (Figure 3).

<br><br>
<img src="{{img}}" class="img-responsive logo1">
<br>
<p i18n>Figure 3	Colour codes used to identify progress across SDG 6 indicators.</p>
        </div>
        <div class="col-lg-12" style="margin-top: 20px;">
            <a class="btn-lg btn btn-info btn-radius" style="margin: 15px 0; min-width: 150px;" routerLink="/introduction/four-element" i18n>Back</a>
            <a class="btn-lg btn btn-primary btn-radius" style="margin: 15px 0; min-width: 150px" routerLink="/introduction/ecourse" i18n>Next</a>
        </div>
        </div>
    </div>
</section>



// WEBPACK FOOTER //
// ./src/app/introduction/summary/summary.component.html